var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AppState } from 'react-native';
import DeviceInfo from 'react-native-device-info';
import Logger from '@/logging/Logger';
const SAMPLE_INTERVAL_MS = 60000;
class HeatTelemetry {
    constructor() {
        this.activeStarts = {};
        this.accumulated = {};
        this.sessionStartedAt = Date.now();
        this.sessionStartBattery = null;
        this.samplingTimer = null;
        this.appStateSub = null;
        this.foregroundElapsedMs = 0;
        this.lastForegroundStart = Date.now();
        this.start = (component) => {
            if (this.activeStarts[component] != null)
                return;
            this.activeStarts[component] = Date.now();
        };
        this.stop = (component) => {
            var _a;
            const startedAt = this.activeStarts[component];
            if (startedAt == null)
                return;
            this.accumulated[component] =
                ((_a = this.accumulated[component]) !== null && _a !== void 0 ? _a : 0) + (Date.now() - startedAt);
            this.activeStarts[component] = undefined;
        };
        this.beginSession = () => __awaiter(this, void 0, void 0, function* () {
            this.sessionStartedAt = Date.now();
            this.accumulated = {};
            this.activeStarts = {};
            this.foregroundElapsedMs = 0;
            this.lastForegroundStart = Date.now();
            this.sessionStartBattery = yield this.readBattery();
            if (this.samplingTimer) {
                clearInterval(this.samplingTimer);
            }
            this.samplingTimer = setInterval(() => {
                this.flushSample().catch(() => { });
            }, SAMPLE_INTERVAL_MS);
            if (this.appStateSub) {
                this.appStateSub.remove();
            }
            this.appStateSub = AppState.addEventListener('change', this.handleAppStateChange);
        });
        this.handleAppStateChange = (state) => {
            const now = Date.now();
            if (state === 'active') {
                if (this.lastForegroundStart == null) {
                    this.lastForegroundStart = now;
                }
            }
            else {
                if (this.lastForegroundStart != null) {
                    this.foregroundElapsedMs += now - this.lastForegroundStart;
                    this.lastForegroundStart = null;
                }
                this.flushSample().catch(() => { });
            }
        };
    }
    readBattery() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const level = yield DeviceInfo.getBatteryLevel();
                // -1 indicates unavailable (emulator 등)
                return level >= 0 ? level : null;
            }
            catch (_a) {
                return null;
            }
        });
    }
    snapshotActive() {
        const now = Date.now();
        const snapshot = Object.assign({}, this.accumulated);
        Object.keys(this.activeStarts).forEach(comp => {
            var _a;
            const startedAt = this.activeStarts[comp];
            if (startedAt != null) {
                snapshot[comp] = ((_a = snapshot[comp]) !== null && _a !== void 0 ? _a : 0) + (now - startedAt);
            }
        });
        return snapshot;
    }
    flushSample() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d;
            const now = Date.now();
            const sessionDurationMs = now - this.sessionStartedAt;
            const fgElapsed = this.foregroundElapsedMs +
                (this.lastForegroundStart != null ? now - this.lastForegroundStart : 0);
            const activeNow = this.snapshotActive();
            const currentBattery = yield this.readBattery();
            const batteryDelta = this.sessionStartBattery != null && currentBattery != null
                ? this.sessionStartBattery - currentBattery
                : null;
            Logger.logHeatSample({
                sessionDurationMs,
                foregroundDurationMs: fgElapsed,
                batteryLevel: currentBattery,
                batteryDeltaSession: batteryDelta,
                gpsWatchMs: (_a = activeNow.gps_watch) !== null && _a !== void 0 ? _a : 0,
                mapNativeViewMs: (_b = activeNow.map_native_view) !== null && _b !== void 0 ? _b : 0,
                cameraActiveMs: (_c = activeNow.camera_active) !== null && _c !== void 0 ? _c : 0,
                imageUploadMs: (_d = activeNow.image_upload) !== null && _d !== void 0 ? _d : 0,
            });
        });
    }
}
export default new HeatTelemetry();
